import React from "react";

const PanelHead = (props) => {
  const { title, Class, onClick, borderWidth = "2px" } = props;

  return (
    <div
      onClick={onClick}
      style={{ borderBottomWidth: borderWidth }}
      className={`p-6 text-start ${Class} bg-secondary dark:bg-darkPrimary border-b-gray-400 text-textColor dark:text-darkTextColor font-bold`}
    >
      {title}
    </div>
  );
};

export default PanelHead;
